import React, { useEffect, useState } from "react";
import axios from "axios";

const Ourproject = () => {
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    axios
      .get("https://feniceshieldchemical.bwsoft.in/api/api/gallery-images/")
      .then((response) => {
        // Flatten images from all services
        const images = Object.values(response.data).flatMap(
          (service) => service.images
        );
        setGalleryImages(images);
      })
      .catch((error) => {
        console.error("Error fetching gallery images:", error);
      });
  }, []);

  return (
    <div>
      <div className="banner">
        <img src="assets/img/about.jpg" alt="img" />
      </div>
      <section id="team" className="team section light-background">
        <div className="container section-title" data-aos="fade-up">
          <h2>Gallery</h2>
        </div>
        <div className="container">
          <div className="row gy-5">
            {galleryImages.length > 0 ? (
              galleryImages.map((image, index) => (
                <div
                  className="col-lg-4 col-md-6 member"
                  data-aos="fade-up"
                  data-aos-delay={100 * (index + 1)}
                  key={image.id}
                >
                  <div className="member-img" id="ourproject">
                    <img
                      src={image.image}
                      className="img-fluid"
                      alt={image.name || "Gallery image"}
                    />
                  </div>
                </div>
              ))
            ) : (
              <p>No images found.</p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ourproject;
